"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _uiTheming = require("@concur/ui-theming");
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _addStylesToDOM = _interopRequireDefault(require("../utils/addStylesToDOM"));
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = _Object$defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* eslint-disable react/prop-types */
var _default = exports["default"] = function _default(WrappedComponent) {
  var _Component = function Component(props) {
    var brandingId = props.brandingId,
      placeholderComp = props.placeholderComp,
      themeName = props.themeName,
      testStylesLoaded = props.testStylesLoaded,
      testIsRetiredBrand = props.testIsRetiredBrand,
      cssFilenamePrefix = props.cssFilenamePrefix;

    // sometimes the theme cookie value gets encoded so we need to decode it here
    var decodedThemeName = themeName ? decodeURI(themeName) : undefined;
    var getThemeToLoad = function getThemeToLoad() {
      if (brandingId === _constants.GATEWAY_BRANDING_ID) {
        return (0, _uiTheming.getDefaultTheme)(brandingId);
      }
      return decodedThemeName || (0, _uiTheming.getDefaultTheme)(brandingId);
    };
    var _useState = (0, _react.useState)(!!testStylesLoaded || process.env.STORYBOOK_ENV === 'true'),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      stylesLoaded = _useState2[0],
      setStylesLoaded = _useState2[1];
    _Component.displayName = WrappedComponent.displayName || WrappedComponent.name || 'withStylesLoaded';
    (0, _react.useEffect)(function () {
      var _context;
      // eslint-disable-next-line camelcase
      var cssUrl = (0, _concat["default"])(_context = "".concat(__webpack_public_path__ || '')).call(_context, cssFilenamePrefix, ".bundle.css");
      if (!testStylesLoaded) {
        (0, _addStylesToDOM["default"])(cssUrl).then(function () {
          setStylesLoaded(true);
        })["catch"](function () {
          // TODO: what do we do here?
        });
      }
    }, []);
    if (!stylesLoaded && typeof placeholderComp === 'function') {
      return placeholderComp();
    }
    var retiredBrands = testIsRetiredBrand;
    var links = (0, _slice["default"])([]).call(document.getElementsByTagName('link')) || [];
    (0, _forEach["default"])(links).call(links, function (item) {
      var _item$href;
      if (item !== null && item !== void 0 && (_item$href = item.href) !== null && _item$href !== void 0 && (0, _includes["default"])(_item$href).call(_item$href, 'retired-brands')) {
        retiredBrands = true;
      }
    });
    return /*#__PURE__*/_react["default"].createElement(_reactUiTheming.ThemeProvider, {
      theme: getThemeToLoad()
    }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
      themeName: decodedThemeName,
      isRetiredBrand: retiredBrands
    })));
  };
  (0, _hoistNonReactStatics["default"])(_Component, WrappedComponent);
  _Component.propTypes = {
    brandingId: _propTypes["default"].number,
    cssFilenamePrefix: _propTypes["default"].string,
    placeholderComp: _propTypes["default"].func,
    themeName: _propTypes["default"].string
  };
  _Component.defaultProps = {
    brandingId: _constants.GATEWAY_BRANDING_ID,
    cssFilenamePrefix: 'main'
  };
  return _Component;
};